// import axios from 'axios';
// import { getCurrency } from '../functions/settings';

import { useTeamStore, actingShowsMoney } from '@/store/useTeamStore';

/** What a hidden money figure looks like (Ray 2026-10-05: "Show money
 *  amounts" off for a helper). The server sends 0 for these, so a number
 *  must never be printed in their place. */
export const HIDDEN_MONEY = '₱ ••••';

/** True while helping an account whose owner hid money amounts. */
export const moneyHidden = () => !actingShowsMoney(useTeamStore.getState().acting);

/** A rate PRICE is a setting the helper may need to edit — never hidden. */
export const priceFormat = (value: number, hasDecimal: boolean) => formatPhp(value, hasDecimal);

export const currencyFormat = (value: number, hasDecimal: boolean) =>
   moneyHidden() ? HIDDEN_MONEY : formatPhp(value, hasDecimal);

const formatPhp = (value: number, hasDecimal: boolean) => {
   const currencyData = {
      code: 'PHP',
      symbol: '₱',
      locale: 'fil-PH',
   };
   const curr = 'currency';
   const sty = currencyData.code || 'PHP';
   const country = currencyData.locale || 'fil-PH';

   // Format the number with potential decimals
   let formattedValue = new Intl.NumberFormat(country, {
      style: curr,
      currency: sty,
      // Always format with two decimal places initially
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   }).format(value);

   // Check if the value is a whole number
   const isWholeNumber = value % 1 === 0;

   // If hasDecimal is false and the value is a whole number, remove the '.00'
   if (hasDecimal && isWholeNumber) {
      formattedValue = formattedValue.replace(/\.00$/, '');
   }

   return formattedValue;
};
